import {Action, ActionReducerMap} from '@ngrx/store';

import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {
    AKTUELLE_TELEFONNUMMER_AENDERN, AKTUELLE_TELEFONNUMMER_SETZEN,
    AKTUELLEN_KONTAKT_AENDERN,
    AKTUELLEN_KONTAKT_SETZEN, AktuellenKontaktAendernAction, AktuellenKontaktSetzenAction, AktuelleTelefonnummerAendernAction, AktuelleTelefonnummerSetzenAction, KONTAKT_BEARBEITUNG_ABBRECHEN, NEUE_TELEFONNUMMER,
    NEUER_KONTAKT, NeuerKontaktAction, PAGE_STATE_RESET, TELEFONNUMMER_BEARBEITUNG_ABBRECHEN
} from './kontakte.actions.ui';
import {Funktionsbereich, FunktionsbereichKontakte, Kontakt, KontaktDetail, KontaktTelefon} from '../../../clients/kontaktverwaltung';
import {
    GET_FUNKTIONSBEREICH_KONTAKTE, GET_FUNKTIONSBEREICH_KONTAKTE_ERFOLGREICH, GET_FUNKTIONSBEREICH_KONTAKTE_FEHLER, GET_KONTAKT_AKTIV_ERFOLGREICH, GET_KONTAKT_DETAIL, GET_KONTAKT_DETAIL_ERFOLGREICH, GET_KONTAKT_DETAIL_FEHLER, GET_KONTAKT_EXTERN_ERFOLGREICH, GET_KONTAKT_TELEFONE,
    GET_KONTAKT_TELEFONE_ERFOLGREICH, GET_KONTAKT_TELEFONE_FEHLER, GetFunktionsbereichKontakteErfolgreichAction, GetKontaktAktivErfolgreichAction, GetKontaktDetailErfolgreichAction, GetKontaktExternErfolgreichAction, GetKontaktTelefoneErfolgreichAction, POST_KONTAKT_ANLEGEN_ERFOLGREICH, POST_KONTAKT_TELEFON_HINZUFUEGEN, PostKontaktAnlegenErfolgreichAction, PostKontaktTelefonHinzufuegenAction
} from '../../../client-ngrx/kontaktverwaltung';


export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    funktionsbereicheKontakteListe: Array<FunktionsbereichKontakte>;
    funktionsbereicheKontakteListeLaden: boolean;
    funktionsbereicheKontakteListeFehler: boolean;

    aktuellerFunktionsbereich: Funktionsbereich;

    aktuellerKontakt: Kontakt;

    originalKontaktDetail: KontaktDetail;
    kontaktDetail: KontaktDetail;
    kontaktDetailLaden: boolean;
    kontaktDetailFehler: boolean;

    kontaktTelefone: Array<KontaktTelefon>;
    kontaktTelefoneLaden: boolean;
    kontaktTelefoneFehler: boolean;
    originaleTelefonnummer: KontaktTelefon;
    aktuelleTelefonnummer: KontaktTelefon;
}

export const initialPageState: PageState = {
    funktionsbereicheKontakteListe: null,
    funktionsbereicheKontakteListeLaden: false,
    funktionsbereicheKontakteListeFehler: false,

    aktuellerFunktionsbereich: null,

    aktuellerKontakt: null,

    originalKontaktDetail: null,
    kontaktDetail: null,
    kontaktDetailLaden: false,
    kontaktDetailFehler: false,

    kontaktTelefone: [],
    kontaktTelefoneLaden: false,
    kontaktTelefoneFehler: false,
    originaleTelefonnummer: null,
    aktuelleTelefonnummer: null
};

export function pageReducer(state = initialPageState, action: Action): PageState {

    switch (action.type) {

        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState);
        }


        /* FUNKTIONSBEREICHE LISTE */
        case GET_FUNKTIONSBEREICH_KONTAKTE: {
            return Object.assign({}, state, <PageState>{
                funktionsbereicheKontakteListeLaden: true,
                funktionsbereicheKontakteListeFehler: false
            });
        }

        case GET_FUNKTIONSBEREICH_KONTAKTE_ERFOLGREICH: {
            const a = <GetFunktionsbereichKontakteErfolgreichAction>action;
            let newState = Object.assign({}, state, <PageState>{
                funktionsbereicheKontakteListe: a.payload,
                funktionsbereicheKontakteListeLaden: false,
                funktionsbereicheKontakteListeFehler: false
            });

            if (state.aktuellerKontakt != null && a.payload !== null) {
                let kontaktIstNochDa = false;
                a.payload.forEach((i) => {
                    if (i.kontakte.findIndex(k => k.kontakt_id === state.aktuellerKontakt.kontakt_id) > -1) {
                        kontaktIstNochDa = true;
                    }
                });
                if (!kontaktIstNochDa) {
                    newState = Object.assign({}, newState, <PageState>{
                        kontaktDetail: null,
                        aktuellerKontakt: null,
                        originalKontaktDetail: null
                    });
                }
            }

            return newState;
        }

        case GET_FUNKTIONSBEREICH_KONTAKTE_FEHLER: {
            return Object.assign({}, state, <PageState>{
                funktionsbereicheKontakteListe: null,
                funktionsbereicheKontakteListeLaden: false,
                funktionsbereicheKontakteListeFehler: true
            });
        }


        /* KONTAKT DETAIL */
        case GET_KONTAKT_DETAIL: {
            return Object.assign({}, state, <PageState>{
                kontaktDetailLaden: true,
                kontaktDetailFehler: false
            });
        }

        case GET_KONTAKT_DETAIL_ERFOLGREICH: {
            const a = <GetKontaktDetailErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                originalKontaktDetail: a.payload,
                kontaktDetail: a.payload,
                kontaktDetailLaden: false,
                kontaktDetailFehler: true
            });
        }

        case GET_KONTAKT_DETAIL_FEHLER: {
            return Object.assign({}, state, <PageState>{
                kontaktDetailLaden: false,
                kontaktDetailFehler: true
            });
        }


        /* KONTAKT TELEFONE */
        case GET_KONTAKT_TELEFONE: {
            return Object.assign({}, state, <PageState>{
                kontaktTelefoneLaden: true,
                kontaktTelefoneFehler: false
            });
        }

        case GET_KONTAKT_TELEFONE_ERFOLGREICH: {
            const a = <GetKontaktTelefoneErfolgreichAction>action;
            let newState = Object.assign({}, state, <PageState>{
                kontaktTelefone: a.payload,
                kontaktTelefoneLaden: false,
                kontaktTelefoneFehler: false
            });

            if (state.aktuelleTelefonnummer != null && a.payload !== null) {
                let telefonIstNochDa = false;
                a.payload.forEach((i) => {
                    if (i.kontakt_telefon_id === state.aktuelleTelefonnummer.kontakt_telefon_id) {
                        telefonIstNochDa = true;
                    }
                });
                if (!telefonIstNochDa) {
                    newState = Object.assign({}, newState, <PageState>{
                        aktuelleTelefonnummer: null,
                        originaleTelefonnummer: null
                    });
                }
            }

            return newState;
        }

        case GET_KONTAKT_TELEFONE_FEHLER: {
            return Object.assign({}, state, <PageState>{
                kontaktTelefoneLaden: false,
                kontaktTelefoneFehler: true
            });
        }

        case GET_KONTAKT_EXTERN_ERFOLGREICH: {
            const a = <GetKontaktExternErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                kontaktDetail: Object.assign({}, state.kontaktDetail, {
                    ist_extern: a.payload.ist_extern
                })
            });
        }

        case GET_KONTAKT_AKTIV_ERFOLGREICH: {
            const a = <GetKontaktAktivErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                kontaktDetail: Object.assign({}, state.kontaktDetail, {
                    ist_aktiv: a.payload.ist_aktiv
                })
            });
        }

        case POST_KONTAKT_ANLEGEN_ERFOLGREICH: {
            const a = <PostKontaktAnlegenErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                kontaktDetail: Object.assign({}, state.kontaktDetail, {
                    kontakt_id: a.kontaktDataRequest.kontakt_id
                }),
                aktuellerKontakt: {
                    kontakt_id: a.kontaktDataRequest.kontakt_id,
                    funktionsbereich_id: a.kontaktDataRequest.funktionsbereich_id,
                    beschreibung: a.kontaktDataRequest.beschreibung,
                    email: a.kontaktDataRequest.email,
                    firma: a.kontaktDataRequest.firma,
                    name: a.kontaktDataRequest.name,
                    vorname: a.kontaktDataRequest.vorname
                }
            });
        }

        case AKTUELLEN_KONTAKT_SETZEN: {
            const a = <AktuellenKontaktSetzenAction>action;

            const liste = Object.assign([], state.funktionsbereicheKontakteListe);
            const index = liste.findIndex(x => x.funktionsbereich.funktionsbereich_id === a.payload.funktionsbereich_id);
            const funktionsbereich = Object.assign({}, liste[index].funktionsbereich);

            return Object.assign({}, state, <PageState>{
                aktuellerKontakt: a.payload,
                aktuellerFunktionsbereich: funktionsbereich
            });
        }

        case NEUER_KONTAKT: {
            const a = <NeuerKontaktAction>action;

            return Object.assign({}, state, <PageState>{
                kontaktDetail: {
                    funktionsbereich_id: a.payload,
                    kontakt_id: null
                },
                aktuelleTelefonnummer: null,
                kontaktTelefone: []
            });
        }

        case AKTUELLEN_KONTAKT_AENDERN: {
            const a = <AktuellenKontaktAendernAction>action;

            return Object.assign({}, state, <PageState>{
                kontaktDetail: a.payload,
                aktuelleTelefonnummer: null
            });
        }

        case KONTAKT_BEARBEITUNG_ABBRECHEN: {
            return Object.assign({}, state, <PageState>{
                kontaktDetail: Object.assign({}, state.originalKontaktDetail)
            });
        }

        case NEUE_TELEFONNUMMER: {
            return Object.assign({}, state, <PageState>{
                aktuelleTelefonnummer: {
                    kontakt_id: state.kontaktDetail.kontakt_id,
                    kontakt_telefon_id: null
                }
            });
        }

        case AKTUELLE_TELEFONNUMMER_SETZEN: {
            const a = <AktuelleTelefonnummerSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                aktuelleTelefonnummer: a.payload
            });
        }

        case AKTUELLE_TELEFONNUMMER_AENDERN: {
            const a = <AktuelleTelefonnummerAendernAction>action;

            return Object.assign({}, state, <PageState>{
                aktuelleTelefonnummer: a.payload
            });
        }

        case TELEFONNUMMER_BEARBEITUNG_ABBRECHEN: {
            return Object.assign({}, state, <PageState>{
                aktuelleTelefonnummer: Object.assign({}, state.originaleTelefonnummer)
            });
        }

        case POST_KONTAKT_TELEFON_HINZUFUEGEN: {
            const a = <PostKontaktTelefonHinzufuegenAction>action;

            return Object.assign({}, state, <PageState>{
                aktuelleTelefonnummer: {
                    kontakt_telefon_id: a.kontaktTelefonDataRequest.kontakt_telefon_id,
                    kontakt_id: a.kontaktTelefonDataRequest.kontakt_id,
                    label: a.kontaktTelefonDataRequest.label,
                    telefon: a.kontaktTelefonDataRequest.telefon
                }
            });
        }

        default: {
            return state;
        }
    }
}


